import * as React from "react";
import thinImage from "../images/thumb_thin_client.png";
import dataCenter from "../images/thin_client_center.png";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";



const Content = () => {
  const { t } = useTranslation("common");
  return (
    <div className="container">
      <div className="row mt-25">
        <div className="d-flex justify-content-left">
          <div>
            <img alt="" src={thinImage} height="100px" />
      </div>
          <div className="p-4">
            <h3 className="text-start">{t("wyse_label")}</h3>
            <h5 className="mt-2">
              {t("tc_h1")}  {t("tc_h2")}
        </h5>
      </div>
        </div>
      </div>
      <div className="row">
        <div className="mt-25">
          <h5 className="">{t("tc_sp1")}</h5>
          <span>{t("tc_c1")}</span>
      </div>
        <div className="mt-25">
          <h5 className="">{t("tc_sp2")}</h5>
          <span>{t("tc_c2")}</span>
      </div>
        <div className="mt-25">
          <h5 className="">{t("tc_sp3")}</h5>
          <span>{t("tc_c3")}</span>
      </div>
        <div className="col-12 mt-25 text-left">
          <img alt="" src={dataCenter} height="300px" width="60%" />
      </div>
        <div className="mt-25">
          <h5 className="">{t("tc_sp4")}</h5>
          <span>{t("tc_c4")}</span>
      </div>
        <div className="col-12 mt-25">
          <h5 className="">{t("tc_sp5")}</h5>
          <span>{t("tc_c5")}</span>
      </div>
        <div className="col-12 mt-25">
          <h5 className="">{t("tc_sp6")}</h5>
      </div>
        <div className="col-12 mt-25">
        <div className="table-responsive">
          <table className="table table-condensed table-bordered fixed_headers">
            <thead>
                <tr className="table-primary">
                  <th rowSpan={2}>{t("features")}</th>
                  <th rowSpan={2}>{t("wyse_label")} {t("st_ver")}</th>
                  <th colSpan={4}>{t("wyse_label")} {t("pr_ver")}</th>
              </tr>
                <tr className="table-primary">
                <th colSpan={2}>
                    {t("pr_cl")}
                </th>
                <th colSpan={2}>
                    {t("pb_cl")}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>
                      {t("tc_hss")}
                  </p>
                </td>
                <td>
                  <p >
                      {t("tc_up_10k")}
                  </p>
                </td>
                <td colSpan={2}>
                  <p >
                      {t("tc_up_120k")}
                  </p>
                </td>
                <td colSpan={2}>
                  <p >
                      {t("tc_up_1m")}
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_lt")}
                  </p>
                </td>
                <td>
                  <p >
                    <a href="https://www.dell.com/support/home/en-us/product-support/product/wyse-wms/drivers">
                        {t("tc_fd")}
                    </a>
                  </p>
                </td>
                <td colSpan={2}>
                  <p >
                      {t("tc_pss")}
                  </p>
                </td>
                <td colSpan={2}>
                  <p >
                      {t("tc_pss")}
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_arc")}
                  </p>
                </td>
                <td>
                  <p >
                      {t("tc_on_prem")}
                  </p>
                </td>
                <td colSpan={2}>
                  <p >
                      {t("tc_on_prem")}
                  </p>
                </td>
                <td colSpan={2}>
                  <p >
                      {t("pb_cl")}
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_mut_ten")}
                  </p>
                </td>
                <td>
                  <p >
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_td1")}
                  </p>
                </td>
                <td>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_td22")}
                  </p>
                </td>
                <td>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_td17")}
                  </p>
                </td>
                <td>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_td20")}
                  </p>
                </td>
                <td>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_td27")}
                  </p>
                </td>
                <td>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_pwr_grp")}
                  </p>
                </td>
                <td>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_ad_sec")}
                  </p>
                </td>
                <td>
                  <p >
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2}>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_api_support")}
                  </p>
                </td>
                <td>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_td8")}<sup>1</sup>
                  </p>
                </td>
                <td>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr >
                <td colSpan={7}>
                  <p>
                      <b>{t("tc_dell_ep")}</b>
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_c_devices")}
                  </p>
                </td>
                <td>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_d_thin")}
                  </p>
                </td>
                <td>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_d_thin_c")}
                  </p>
                </td>
                <td>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>
              <tr>
                <td>
                  <p>
                      {t("tc_d_thin_10")}
                  </p>
                </td>
                <td>
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>
                <td colSpan={2} valign="top">
                  <p className="circle-blue">
                    &#11044;
                  </p>
                </td>

              </tr>

            </tbody>
          </table>
        </div>
      </div>
        <div className="col-12 text-center">
          <div id="tc_button"><div><a className="btn text-light text-decoration-none" href="#/trial/tc">{t("pro_trial_btn")}</a></div>
         
          <div id="stwmsstd">  <a className="btn text-light text-decoration-none" href="#/stdInstall/new" >{t("start_wms_std")}</a></div>

          <div id="wmsstdrnw">  <a className="btn text-light text-decoration-none" href="#/stdInstall/renew" >{t("renew_std")}</a></div>
          </div>
          
      </div>
        <div className="col-11 row mt-25">
          <div> {t("tc_l_m")} <a href="http://www.dell.com/CloudClientWorkspace"> {t("tc_cl_c")} </a></div>
      </div>
        <div className="col-11 row mt-25">
          <div>{t("tc_1_df")} <a href="http://www.dell.com/servicecontracts/global"> {t("tc_1_lnk")} </a></div>
        </div>
      </div>
    </div>
  )
}


export default function ThinClient() {
  return (
    <div className="wrapper">
      <Header />
      <Content />
      <Footer />
    </div>
  );

}